var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.75C6.25 3.41848 6.3817 3.10054 6.61612 2.86612C6.85054 2.6317 7.16848 2.5 7.5 2.5H25C25.3315 2.5 25.6495 2.6317 25.8839 2.86612C26.1183 3.10054 26.25 3.41848 26.25 3.75V26.25C26.25 26.5815 26.1183 26.8995 25.8839 27.1339C25.6495 27.3683 25.3315 27.5 25 27.5H7.5C7.16848 27.5 6.85054 27.3683 6.61612 27.1339C6.3817 26.8995 6.25 26.5815 6.25 26.25V3.75Z",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3.75V26.25",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.75H8.75",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15H8.75",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 21.25H8.75",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 2.5H24.375",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 27.5H24.375",
    stroke: "#023047",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBinder);
export default __webpack_public_path__ + "static/media/info-binder.5b5e9f59e5d137f295a4bf198b8823b0.svg";
export { ForwardRef as ReactComponent };